import {Category} from '@spartacus/core';

export const CATEGORY_FEATURE = 'category';
export const CATEGORY = '[Category] Category';

export interface StateWithCategory {
  [CATEGORY_FEATURE]: CustomCategoryState;
}

export interface CustomCategoryState {
  category?: Category;
}
